export const NZ_SIT_DOMAIN = 'sit-nz.paydirect.dev.myob.com';
export const NZ_PROD_DOMAIN = 'nz.paydirect.myob.com';

export const shouldRedirectToNzBasedOnCountry = (url: URL, country: string) => {
  return !(url.hostname === NZ_PROD_DOMAIN || url.hostname === NZ_SIT_DOMAIN)
    && country === 'NZ';
};

function getHostnameBasedOnEnvURL(url: URL) {
  const isProductionUrl = url.hostname === 'paydirect.myob.com';
  return isProductionUrl ? NZ_PROD_DOMAIN : NZ_SIT_DOMAIN;
}

export const getHostnameForNz = (url: URL) => {
  const updatedURL: URL = new URL(url.toString());
  updatedURL.hostname = getHostnameBasedOnEnvURL(url);
  updatedURL.port = '';
  return updatedURL;
};
